import { FC } from 'react'
import { ReactComponent as MentionIcon } from 'src/assets/svg/akar-icons_mention.svg'
import styles from './totalMentionsCard.module.scss'

interface TotalMentionsCardProps {
  count?: number
  hasData?: boolean
  negativePercentage?: number
  neutralPercentage?: number
  positivePercentage?: number
}

export const TotalMentionsCard: FC<TotalMentionsCardProps> = ({
  count = 12450,
  hasData = false,
  negativePercentage = 15,
  neutralPercentage = 30,
  positivePercentage = 55,
}) => {
  const sources = [
    {
      color: '#8080FF',
      count: Math.round((count * positivePercentage) / 100).toLocaleString(),
      name: 'Positive',
      percentage: positivePercentage,
    },
    {
      color: '#D3D4D5',
      count: Math.round((count * neutralPercentage) / 100).toLocaleString(),
      name: 'Neutral',
      percentage: neutralPercentage,
    },
    {
      color: '#FF6833',
      count: Math.round((count * negativePercentage) / 100).toLocaleString(),
      name: 'Negative',
      percentage: negativePercentage,
    },
  ]

  return (
    <div className={styles.card}>
      <div className={styles.headerSection}>
        <div className={styles.header}>
          <MentionIcon className={styles.icon} />
          <h3 className={styles.title}>Total Mentions</h3>
          {hasData && (
            <span className={styles.totalCount}>{count.toLocaleString()}</span>
          )}
        </div>
        <span className={styles.subtitle}>Avg. Per Keyword</span>
      </div>
      {hasData ? (
        <div className={styles.content}>
          {sources.map((source) => (
            <div className={styles.sourceRow} key={source.name}>
              <div className={styles.barWrapper}>
                <div
                  className={styles.bar}
                  style={{
                    backgroundColor: source.color,
                    width: `${source.percentage}%`,
                  }}
                />
              </div>
              <div className={styles.stats}>
                <div className={styles.labelGroup}>
                  <span className={styles.percentage}>
                    {source.percentage}%
                  </span>
                  <span className={styles.sourceName}>{source.name}</span>
                </div>
                <span className={styles.count}>{source.count}</span>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className={styles.noData}>No Data</div>
      )}
    </div>
  )
}
